var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAstr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.99 16c0 .744-.075 1.47-.216 2.174-.396-1.066-1.082-2.218-2.204-3.385a11.193 11.193 0 0 0-2.753-2.07c.206-2.425-.06-4.905-1.33-5.602-1.868-1.023-3.795-.602-3.915 1.566-.096 1.734 1.485 2.449 2.288 2.59 0 .09 0 .183-.003.276-2-.535-3.97-.594-5.408-.244.065-.45.167-.91.31-1.38.84-2.762 2.9-4.086 4.696-4.64C23.343 6.402 26.99 10.776 26.99 16zM12.636 5.535C8.213 6.955 5.011 11.104 5.011 16c0 1.112.166 2.186.473 3.198 1.376 1.288 3.562 2.428 6.392 1.77a9.413 9.413 0 0 0 1.477-.471c-1.042-1.094-1.992-2.88-2.521-4.93-.105.056-.21.114-.312.174.28.766.452 2.493-1.098 3.277-1.938.98-3.266-.479-3.313-2.607-.032-1.47 2.046-2.965 4.289-4a11.133 11.133 0 0 1 .418-3.28c.449-1.552 1.101-2.72 1.823-3.595zm.952 8.957c.404 1.656 1.3 3.09 2.415 4.253 1.215-1.199 1.991-2.71 2.423-4.265-1.622-.449-3.294-.376-4.839.012zm4.713 6.115c1.514-1.51 2.573-3.247 2.966-4.697v-.004c.39.3.77.645 1.136 1.036 2.033 2.173 2.095 4.703 1.632 6.552A10.96 10.96 0 0 1 16 26.989a10.95 10.95 0 0 1-7.392-2.858c1.125.192 2.47.176 4.05-.214a11.185 11.185 0 0 0 3.155-1.341c2.025 1.433 4.373 2.498 5.636 1.732 1.819-1.106 2.417-2.986.6-4.174-1.454-.95-2.863.062-3.386.687-.12-.07-.241-.142-.36-.216zM30 16c0 7.732-6.268 14-14 14S2 23.732 2 16 8.268 2 16 2s14 6.268 14 14z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstr);
export default __webpack_public_path__ + "static/media/ASTR.e422a8519751851bf012abed76019af2.svg";
export { ForwardRef as ReactComponent };